﻿import { AdHocAudit, AssetAudit, JobAudit, QxAudit } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;

export const QxAuditService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getQxAudits = async (startDate?: Date, endDate?: Date): Promise<QxAudit[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<QxAudit[]>('GetAsync', startDate, endDate);
    } else {
      throw 'QxAudit DotNet Object Reference has not yet been implemented';
    }
  };

  const getJobAudits = async (startDate?: Date, endDate?: Date): Promise<JobAudit[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<JobAudit[]>('GetJobAuditsAsync', startDate, endDate);
    } else {
      throw 'QxAudit DotNet Object Reference has not yet been implemented';
    }
  };

  const getAssetAudits = async (startDate?: Date, endDate?: Date): Promise<AssetAudit[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<AssetAudit[]>('GetAssetAuditsAsync', startDate, endDate);
    } else {
      throw 'QxAudit DotNet Object Reference has not yet been implemented';
    }
  };

  const getAdHocAudits = async (startDate?: Date, endDate?: Date): Promise<AdHocAudit[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<AdHocAudit[]>('GetAdHocAuditsAsync', startDate, endDate);
    } else {
      throw 'QxAudit DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getQxAudits,
    getJobAudits,
    getAssetAudits,
    getAdHocAudits,
  };
})();
